const formatAmount = (
  amount: number,
  currency?: string,
  decimals: number = 2
): string => {
  const options = { minimumFractionDigits: decimals };
  const formatted = amount.toLocaleString("en-US", options);

  return [currency, formatted].filter(Boolean).join(" ");
};

export { formatAmount };
